import React from "react";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";

interface DownloadWithEmailButtonProps {
  primaryColor: string;
  handleClick: Function;
}

const DownloadWithEmailButton: React.FC<DownloadWithEmailButtonProps> = ({
  primaryColor,
  handleClick
}) => (
  <div
    className="geo-lt__cart-icon geo-btn--caps"
    onClick={e => {
      e.preventDefault();
      handleClick();
    }}
    style={{
      background: ContrastForegroundUtility.lbFgColor(primaryColor),
      borderColor: ContrastForegroundUtility.lbFgColor(primaryColor),
      color: "white"
    }}
  >
    <span
      className="fa fa-download"
      style={{ color: "white", marginRight: 8 }}
    />
    <span>Download now</span>
  </div>
);

export default DownloadWithEmailButton;
